module.exports = __webpack_public_path__ + "static/media/book-mockup-store-xl.d0e53e54.png";